import { render, staticRenderFns } from "./down-app.vue?vue&type=template&id=284cc524&scoped=true&"
import script from "./down-app.vue?vue&type=script&lang=js&"
export * from "./down-app.vue?vue&type=script&lang=js&"
import style0 from "./down-app.vue?vue&type=style&index=0&id=284cc524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284cc524",
  null
  
)

export default component.exports